import { bindServices } from '@/services/api';
import _ from 'lodash';

const api = bindServices('approvers');

const typeApprover = [
  {
    id: 1,
    nameKey: 'menu.configuration.approvers.userGroup',
    descriptionKey: 'approvers.types.userGroup.description',
    route: 'GlobalUserGroupApproverUser',
  },
  {
    id: 2,
    nameKey: 'menu.configuration.approvers.groupAndPosition',
    descriptionKey: 'approvers.types.groupAndPosition.description',
    route: 'GlobalUserGroupApproverByPosition',
  },
  {
    id: 3,
    nameKey: 'menu.configuration.approvers.globalUserGroupAndArea',
    descriptionKey: 'approvers.types.globalUserGroupAndArea.description',
    route: 'GlobalUserGroupApproverByArea',
  },
  {
    id: 4,
    nameKey: 'menu.configuration.approvers.entity',
    descriptionKey: 'approvers.types.entity.description',
    route: 'GlobalEntityApproverUser',
  },
  {
    id: 5,
    nameKey: 'menu.configuration.approvers.entityAndUserGroup',
    descriptionKey: 'approvers.types.entityAndUserGroup.description',
    route: 'GlobalEntityApproverByUserGroup',
  },
  {
    id: 6,
    nameKey: 'menu.configuration.approvers.entityAndPosition',
    descriptionKey: 'approvers.types.entityAndPosition.description',
    route: 'GlobalEntityApproverByPosition',
  },
  {
    id: 7,
    nameKey: 'menu.configuration.approvers.globalEntityAndArea',
    descriptionKey: 'approvers.types.globalEntityAndArea.description',
    route: 'GlobalEntityApproverByArea',
  },
];

const Model = {
  namespace: 'approvers',
  state: {
    list: [],
    newApprover: false,
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(api.getAll, {
          route: 'approvers/count',
          params: payload,
        });
        yield put({
          type: 'queryApproversGroups',
          payload: response,
        });
      } catch (error) {
        /*  */
      }
    },

    *hideAllForms(state, { put }) {
      yield put({ type: 'hideAll' });
    },
  },

  reducers: {
    queryApproversGroups(state, { payload }) {
      const data = _.map(typeApprover, (item) => {
        return {
          ...item,
          count: _.find(payload, { type: item.id })?.count ?? 0,
        };
      });

      return {
        ...state,
        data,
      };
    },

    hideAll(state) {
      return {
        ...state,
        newApprover: false,
        approverDetails: false,
      };
    },
  },
};

export default Model;
